export const variables = {
  UserName: "",
  Mobile: "",
};
